<template>
  <div class="content-container" :class="wrapperClasses">
    <image-block
      :icon="content.icon"
      :image="content.image"
      class="image-wrapper"
    />
    <div class="message-wrapper">
      <h3>{{ content.title }}</h3>
      <p v-html="content.body"></p>
    </div>
    <router-link v-if="content.button" :to="{ name: 'login'}" class="button">
      {{ content.button }}
    </router-link>
    <loading-spinner v-if="content.loading" />
  </div>
</template>

<script>
import ImageBlock from './ImageBlock';
import LoadingSpinner from './LoadingSpinner';

export default {
  name: 'TwoFactorAuhContent',
  components: {
    ImageBlock,
    LoadingSpinner,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  computed: {
    wrapperClasses() {
      return this.content.icon === 'danger' ? 'container-wrapper-danger' : 'container-wrapper-primary';
    },
  },
};
</script>

<style lang="sass" scoped>
  h3
    font-size: 24px
    font-weight: 500
    line-height: 29px
    margin-bottom: 15px
    white-space: nowrap

  p
    opacity: 0.75
    font-weight: 500
    font-size: 14px
    line-height: 20px

  .content-container
    position: relative
    display: flex
    flex-flow: column
    justify-content: center
    align-items: center

  .message-wrapper
    text-align: center
    max-width: 295px

  .image-wrapper
    position: relative
    display: flex
    justify-content: center
    margin-bottom: 25px
    min-height: 250px

  .button
    width: 100%
    max-width: 275px
    margin: 20px 0
    background-color: #000
    font-weight: 500
    font-size: 14px
    line-height: 20px
</style>
